
let Store = {
    state:{
        hostname:location.hostname,
        isOnline:location.hostname == 'h5.xinpianchang.com',
        isTest: location.hostname == 'h5.test.xinpianchang.com',
        isHttpsTest: location.hostname == 'h5-test.xinpianchang.com',
        comments:0,
        baseUrl:'http://www.xinpianchang.com',
        baseAppUrl:'https://app-test.xinpianchang.com',
        passportUrl:'https://passport-test.xinpianchang.com/api/v1',
        basePassportUrl: 'https://passport-test.xinpianchang.com',
        universalUrl:'https://universal-test.xinpianchang.com',
        yybUrl: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.xinpianchang.newstudios&utm_source=h5.xinpianchang.com&utm_medium=cpc&utm_term=H5%E4%B8%8B%E8%BD%BDAPP%E6%8C%89%E9%92%AE&utm_content=H5%E4%B8%8B%E8%BD%BDAPP%E6%8C%89%E9%92%AE&utm_campaign=APP%E4%B8%8B%E8%BD%BD',
        loginUrl:'',
        callbackUrl: encodeURIComponent(location.href),
        LoginUserId: 0,
        LoginUser: null,
        windowHeight:$(window).height()   //window的高度
    },
    getters: {
        windowHeight: state => {
            return state.windowHeight = $(window).height();
        },
        baseUrl: state => {
            switch (state.hostname){
                case 'node.llb.xinpianchang.com':
                    // return state.baseUrl = 'http://xpc.llb.vmovier.cc';
                    return state.baseUrl = 'https://www-test.xinpianchang.com';
                case 'h5.test.xinpianchang.com':
                    return state.baseUrl = 'https://www-test.xinpianchang.com';
                case 'h5.xinpianchang.com':
                    return state.baseUrl =  'https://www.xinpianchang.com';
                default:
                    return state.baseUrl = 'https://www-test.xinpianchang.com'
            }
        },
        baseAppUrl: state => {
            switch (state.hostname){
                case 'node.llb.xinpianchang.com':
                    // return state.baseUrl = 'http://xpc.llb.vmovier.cc';
                    return state.baseAppUrl = 'https://app-test.xinpianchang.com';
                case 'h5.test.xinpianchang.com':
                    return state.baseAppUrl = 'https://app-test.xinpianchang.com';
                case 'h5.xinpianchang.com':
                    return state.baseAppUrl =  'https://app.xinpianchang.com';
                default:
                    return state.baseAppUrl = 'https://app-test.xinpianchang.com'
            }
        },
        baseOpenapiUrl: state => {
            switch (state.hostname){
                case 'node.llb.xinpianchang.com':
                    // return state.baseUrl = 'http://xpc.llb.vmovier.cc';
                    return state.baseOpenapiUrl = 'https://openapi-test.vmovier.com';
                case 'h5.test.xinpianchang.com':
                    return state.baseOpenapiUrl = 'https://openapi-test.vmovier.com';
                case 'h5.xinpianchang.com':
                    return state.baseOpenapiUrl =  'https://openapi-vtom.vmovier.com';
                default:
                    return state.baseOpenapiUrl = 'https://openapi-test.vmovier.com'
            }
        },
        baseModapiUrl: state => {
            switch (state.hostname){
                case 'node.llb.xinpianchang.com':
                    // return state.baseUrl = 'http://xpc.llb.vmovier.cc';
                    return state.baseOpenapiUrl = 'https://mod-api-test.xinpianchang.com';
                case 'h5.test.xinpianchang.com':
                    return state.baseOpenapiUrl = 'https://mod-api-test.xinpianchang.com';
                case 'h5.xinpianchang.com':
                    return state.baseOpenapiUrl =  'https://mod-api.xinpianchang.com';
                default:
                    return state.baseOpenapiUrl = 'https://mod-api-test.xinpianchang.com'
            }
        },
        passportUrl: state => {
            switch (state.hostname){
                case 'node.llb.xinpianchang.com':
                    // return state.baseUrl = 'http://xpc.llb.vmovier.cc';
                    return state.passportUrl = 'https://passport-test.xinpianchang.com/api/v1';
                case 'h5.test.xinpianchang.com':
                    return state.passportUrl = 'https://passport-test.xinpianchang.com/api/v1';
                case 'h5.xinpianchang.com':
                    return state.passportUrl = 'https://passport.xinpianchang.com/api/v1';
                default:
                    return state.passportUrl = 'https://passport-test.xinpianchang.com/api/v1'
            }
        },
        basePassportUrl: state => {
            switch (state.hostname){
                case 'node.llb.xinpianchang.com':
                    // return state.baseUrl = 'http://xpc.llb.vmovier.cc';
                    return state.passportUrl = 'https://passport-test.xinpianchang.com';
                case 'h5.test.xinpianchang.com':
                    return state.passportUrl = 'https://passport-test.xinpianchang.com';
                case 'h5.xinpianchang.com':
                    return state.passportUrl = 'https://passport.xinpianchang.com';
                default:
                    return state.passportUrl = 'https://passport-test.xinpianchang.com'
            }
        },
        universalUrl: state => {
            switch (state.hostname){
                case 'node.llb.xinpianchang.com':
                    // return state.baseUrl = 'http://xpc.llb.vmovier.cc';
                    return state.universalUrl = 'https://universal-test.xinpianchang.com';
                case 'h5.test.xinpianchang.com':
                    return state.universalUrl = 'https://universal-test.xinpianchang.com';
                case 'h5.xinpianchang.com':
                    return state.universalUrl = 'https://universal.xinpianchang.com﻿';
                default:
                    return state.universalUrl = 'https://universal-test.xinpianchang.com'
            }
        },
        
        loginUrl: (state,getters) => {

            return state.loginUrl = getters.baseUrl + '/index.php?app=user&ac=login&callback=' + encodeURIComponent(location.href);

        },
        loginOutUrl: (state,getters) => {

            return state.loginUrl = getters.baseUrl + '/user/login/ts-out?callback=' + encodeURIComponent(location.href);

        },
        routePath: state => {

            return state.isOnline || state.isTest || state.isHttpsTest  ? '' : '/View';

        },
        // 万位数取整
        interceptNum: state => (num) => {
            if(num >= 10000){
                var num1 = num / 10000;
                var num2 = Number(parseFloat(num1).toFixed(3).slice(0, -2)) + 'w';
            }else{
                return num;
            }
            return num2;
        },
    },
    mutations:{
        loginState (state,LoginUser) {
            // console.log('LoginUserLoginUserLoginUser',LoginUser);
            state.LoginUserId = LoginUser.user_id;
            state.LoginUser = LoginUser;
        },

        downloadShow (state) {
            state.download = 1;
        },

        sendMsg (state,userid){
            if(state.LoginUserId){

                location.href = state.baseUrl + '/user/message/ts-add/touserid-' + userid;

            }else{

                location.href = state.baseUrl + '/user/mcard/ts-mcard_form/id-' + userid;

            }

        },

        commentsShow (state) {
          state.comments = 1
        }
    }
}

export default Store;



// WEBPACK FOOTER //
// ./source/lib/js/store.js